import RoutesBuilder from '../../lib/routes/RoutesBuilder';
import requestRoutes from './routes/request_routes.json';
import links from './routes/links.json';

// Guide: https://gitlab.com/decisely/juno/-/wikis/How-to-AJAX-in-Juno

function buildBy(routesArray) {
  const builder = new RoutesBuilder();
  routesArray.map((route) => builder.addRoute(route.url, { type: route.type }));
  return builder.getRoutes();
}

function buildRequestRoutes() {
  return buildBy(requestRoutes);
}

function buildLinks() {
  return buildBy(links);
}

export { buildLinks, buildRequestRoutes };
